import { render, staticRenderFns } from "./bf-social-auth.vue?vue&type=template&id=4a664d1c&scoped=true&lang=pug&"
import script from "./bf-social-auth.vue?vue&type=script&lang=js&"
export * from "./bf-social-auth.vue?vue&type=script&lang=js&"
import style0 from "./bf-social-auth.vue?vue&type=style&index=0&id=4a664d1c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a664d1c",
  null
  
)

export default component.exports